import { useField } from "react-final-form";
import { datesError } from "./LoanForm";
import styles from './DatesErrorField.module.scss'



const DatesErrorField = () => {
    const { meta: startDateMeta } = useField("startDate", { subscription: { touched: true, error: true } });

    return (
        <>
            {startDateMeta.touched && startDateMeta.error && startDateMeta.error == datesError.withingRange ?

                <div className={styles.errorMessage}>
                    <div>{startDateMeta.error}</div>
                </div> : null
            }
        </>
    )
}

export default DatesErrorField;